export const USER_ROLES = Object.freeze({
  EMPLOYEE: "Employee",
  CLIENT: "Client",
  APP_OWNER: "App Owner",
  ADMIN: "Admin",
});

export default USER_ROLES;